
import * as utils from "./utils";

export function cargoToForm(cargo) {
    let cleanedCargo = Object.assign({}, cargo);

    if (utils.notNullNorUndefined(cleanedCargo.fog) && cleanedCargo.fog.id !== undefined) {
        cleanedCargo.fog = cleanedCargo.fog.id;
    }

    if (utils.notNullNorUndefined(cleanedCargo.commodity) && cleanedCargo.commodity.id !== undefined) {
        cleanedCargo.commodity = cleanedCargo.commodity.id;
    }
    if (utils.notNullNorUndefined(cleanedCargo.clientRate) && cleanedCargo.clientRate.id !== undefined) {
        cleanedCargo.clientRate = cleanedCargo.clientRate.id;
    }
    if (utils.notNullNorUndefined(cleanedCargo.underwriterRate) && cleanedCargo.underwriterRate.id !== undefined) {
        cleanedCargo.underwriterRate = cleanedCargo.underwriterRate.id;
    }

    let dischargingPortCounter = 0;
    let loadingPortCounter = 0;

    if (utils.notNullNorUndefined(cleanedCargo.cargoPorts)) {
        for (let i = 0; i < cargo.cargoPorts.length; i++) {
            if (cargo.cargoPorts[i] !== undefined) {
                if (dischargingPortCounter === 0 && cargo.cargoPorts[i].operation === 'DISCHARGE') {
                    cleanedCargo.dischargingPort = {...cargo.cargoPorts[i]};
                    if (utils.notNullNorUndefined(cleanedCargo.dischargingPort.port) && cleanedCargo.dischargingPort.port.id !== undefined) {
                        cleanedCargo.dischargingPort.port = cleanedCargo.dischargingPort.port.id;
                    }
                    if (utils.notNullNorUndefined(cleanedCargo.dischargingPort.cargo) && cleanedCargo.dischargingPort.cargo.id !== undefined) {
                        cleanedCargo.dischargingPort.cargo = cleanedCargo.dischargingPort.cargo.id;
                    }

                    if (cleanedCargo.dischargingPort.isConfirmed === 1) {
                        cleanedCargo.dischargingPort.isConfirmed = true
                    }
                    else if (cleanedCargo.dischargingPort.isConfirmed === 0) {
                        cleanedCargo.dischargingPort.isConfirmed = false
                    }
                }

                if (loadingPortCounter === 0 && cargo.cargoPorts[i].operation === 'LOAD') {
                    cleanedCargo.loadingPort = {...cargo.cargoPorts[i]};
                    if (utils.notNullNorUndefined(cleanedCargo.loadingPort.port) && cleanedCargo.loadingPort.port.id !== undefined) {
                        cleanedCargo.loadingPort.port = cleanedCargo.loadingPort.port.id;
                    }
                    if (utils.notNullNorUndefined(cleanedCargo.loadingPort.cargo) && cleanedCargo.loadingPort.cargo.id !== undefined) {
                        cleanedCargo.loadingPort.cargo = cleanedCargo.loadingPort.cargo.id;
                    }

                    if (cleanedCargo.loadingPort.isConfirmed === 1) {
                        cleanedCargo.loadingPort.isConfirmed = true
                    }
                    else if (cleanedCargo.loadingPort.isConfirmed === 0) {
                        cleanedCargo.loadingPort.isConfirmed = false
                    }
                }

                if (dischargingPortCounter === 1 && loadingPortCounter === 1) {
                    break;
                }
            }
        }
    }

    return cleanedCargo;
}

export function calculateShortage(cargoes) {
    let newCargoes = [];

    for (let i = 0; i < cargoes.length; i++) {
        if (utils.notNullNorUndefined(cargoes[i].outturnTonnes) && cargoes[i].outturnTonnes > 0) {
            let newCargo = {...cargoes[i]};

            newCargo.shortageTonnes = cargoes[i].quantity - cargoes[i].outturnTonnes;
            newCargo.shortagePercent = newCargo.shortageTonnes / cargoes[i].quantity;
            newCargoes.push(newCargo);
        } else {
            newCargoes.push(cargoes[i]);
        }
    }

    return newCargoes;
}

export function flattenCommodity(cargoes) {
    if (Array.isArray(cargoes)) {
        let newCargoes = [];
        for (let i = 0; i < cargoes.length; i++) {
            let newCargo = cargoes[i];
            if (utils.notNullNorUndefined(newCargo.commodity)) {
                newCargoes.push({...newCargo, commodityName: newCargo.commodity.name});
            } else {
                newCargoes.push(newCargo);
            }
        }
        return newCargoes;
    } else if (utils.notNullNorUndefined(cargoes.commodity)) {
        return {...cargoes, commodityName: cargoes.commodity.name};
    }
    return cargoes;
}



// WEBPACK FOOTER //
// ./src/utils/cargo.js